import { NATIONS } from "../data/nations";
import KushFlag from "./KushFlag";

const TENETS = [
  "AFRICA WITHOUT BORDERS",
  "55 NATIONS UNITED",
  "ONE PASSPORT",
  "FREE TRADE FOR YOUTH & BUSINESS",
  "INITIATED BY KINGDOM OF KUSH",
  "NO BORDER FOR PROGRESS",
];

function Row() {
  return (
    <div className="flex shrink-0 items-center">
      {TENETS.map((t) => (
        <span key={t} className="flex items-center">
          <span className="font-official text-xs sm:text-sm tracking-[0.3em] uppercase text-[#00A651]/80 px-8 whitespace-nowrap">
            {t}
          </span>
          <svg viewBox="0 0 24 24" className="w-3 h-3 fill-[#00A651]/50" aria-hidden="true">
            <path d="M12 2l2.4 7.6H22l-6.2 4.5 2.4 7.4L12 17l-6.2 4.5 2.4-7.4L2 9.6h7.6L12 2z" />
          </svg>
        </span>
      ))}
    </div>
  );
}

function FlagRow() {
  return (
    <div className="flex shrink-0 items-center">
      {NATIONS.map((n) => (
        <span key={n.code} className="flex items-center gap-3 px-6">
          {n.founding ? (
            <KushFlag className="w-8 h-[22px] rounded-[2px]" />
          ) : (
            <img
              src={`https://flagcdn.com/w80/${n.code.toLowerCase()}.png`}
              alt={`${n.name} flag`}
              loading="lazy"
              className="w-8 h-[22px] object-cover rounded-[2px] border border-white/10"
            />
          )}
          <span className="font-official text-[10px] tracking-[0.25em] uppercase text-[#8A99AD] whitespace-nowrap">
            {n.name}
          </span>
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div>
      <div className="relative border-y border-[#00A651]/15 bg-[#121519] py-5 overflow-hidden marquee-mask" data-testid="tenets-marquee">
        <div className="flex w-max animate-marquee">
          <Row />
          <Row />
        </div>
      </div>
      <div className="relative border-b border-[#00A651]/15 bg-[#0A0C0E] py-4 overflow-hidden marquee-mask" data-testid="flags-marquee">
        <div className="flex w-max animate-marquee-reverse">
          <FlagRow />
          <FlagRow />
        </div>
      </div>
    </div>
  );
}
